import { render, staticRenderFns } from "./ResidentAgingWidget.vue?vue&type=template&id=76a35bcc&scoped=true&"
import script from "./ResidentAgingWidget.vue?vue&type=script&lang=ts&"
export * from "./ResidentAgingWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentAgingWidget.vue?vue&type=style&index=0&id=76a35bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a35bcc",
  null
  
)

export default component.exports